import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

/**
 * Sube un documento asociado a una entidad del backend.
 * @param {Object} params
 * @param {string} params.className - Nombre de la entidad (p.ej. 'ImprovementProposal')
 * @param {number} params.idClassName - ID de la entidad
 * @param {string} params.fileName - Nombre final del fichero (incluyendo extensión)
 * @param {string} params.base64DataUrl - Data URL completa (data:<mime>;base64,XXXXX) o solo la parte base64
 * @returns {Promise<Object|null>} Documento creado o null
 */
export async function addDocument({ className, idClassName, fileName, base64DataUrl }) {
  if (!base64DataUrl) return null;
  const base64Part = base64DataUrl.includes(',') ? base64DataUrl.split(',')[1] : base64DataUrl;
  const response = await getAPIResponse('/v1/document/add', {
    path: { fileName, base64decode: base64Part },
    className,
    idClassName: parseInt(idClassName, 10)
  }, 'POST');
  return response;
}
